import { useEffect, useMemo, useRef } from "react";
import { GatheringOrLocalPhoto } from "src/hooks/useGatheringPhotosWithLocal";
import useStateRef from "src/hooks/useStateRef";
import { Timeout } from "src/types/time";

interface ShouldBeEmptyProps {
	loading: boolean;
	refreshing: boolean;
	photos: GatheringOrLocalPhoto[];
}

const getShouldBeEmpty = ({ loading, refreshing, photos }: ShouldBeEmptyProps) => {
	return !(loading || refreshing || photos.length > 0);
};

const useGatheringHomeIsEmpty = (shouldBeEmptyProps: ShouldBeEmptyProps) => {
	const [delayedIsEmpty, setDelayedIsEmpty, delayedIsEmptyRef] = useStateRef(false);

	const timeout = useRef<Timeout | null>(null);
	useEffect(() => {
		if (timeout.current) clearTimeout(timeout.current);
		timeout.current = setTimeout(() => {
			const shouldBeEmpty = getShouldBeEmpty(shouldBeEmptyProps);
			if (delayedIsEmptyRef.current !== shouldBeEmpty) {
				setDelayedIsEmpty(shouldBeEmpty);
			}
		}, 100);
	}, [shouldBeEmptyProps, delayedIsEmptyRef, setDelayedIsEmpty]);

	useEffect(() => {
		return () => {
			if (timeout.current) clearTimeout(timeout.current);
		};
	}, []);

	const isEmpty = useMemo(() => {
		const shouldBeEmpty = getShouldBeEmpty(shouldBeEmptyProps);
		if (!shouldBeEmpty) {
			return false;
		}
		return delayedIsEmpty;
	}, [delayedIsEmpty, shouldBeEmptyProps]);

	return {
		isEmpty,
	};
};
export default useGatheringHomeIsEmpty;
